"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PopoverMultiSelect;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
require("./styles.scss");
var _Popover = _interopRequireDefault(require("../PopoverMenu/Popover"));
function PopoverMultiSelect(props) {
  var anchorElement = props.anchorElement,
    initialSelection = props.initialSelection,
    menuAlign = props.menuAlign,
    onChange = props.onChange,
    sections = props.sections,
    setAnchorElement = props.setAnchorElement;
  var _useState = (0, _react.useState)(initialSelection),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selection = _useState2[0],
    setSelection = _useState2[1];
  var addToSelection = function addToSelection(value) {
    var newSelection = (0, _toConsumableArray2.default)(selection);
    newSelection.push(value);
    setSelection(newSelection);
    onChange(newSelection);
  };
  var removeFromSelection = function removeFromSelection(index) {
    var newSelection = (0, _toConsumableArray2.default)(selection);
    newSelection.splice(index, 1);
    setSelection(newSelection);
    onChange(newSelection);
  };
  var iconSpacer = function iconSpacer() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "popover-multi-select__checkmark-spacer"
    });
  };
  return /*#__PURE__*/_react.default.createElement(_Popover.default, {
    sections: sections,
    handleClick: function handleClick(item) {
      var itemIndex = selection.findIndex(function (s) {
        return s === item.value;
      });
      if (itemIndex >= 0) {
        removeFromSelection(itemIndex);
      } else {
        addToSelection(item.value);
      }
    },
    anchorElement: anchorElement,
    setAnchorElement: setAnchorElement,
    itemRenderer: function itemRenderer(item) {
      var selected = selection.find(function (s) {
        return s === item.value;
      });
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, selected ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: "checkmark",
        className: "popover-multi-select__checkmark-selection"
      }) : iconSpacer(), /*#__PURE__*/_react.default.createElement(_material.ListItemText, null, item.label));
    },
    menuAlign: menuAlign
  });
}